export const COMMERCE = 'COMMERCE';
export const AllEnrolledProductLines = [COMMERCE];